<template>
	<div class="spinner-checkmark-combo">
		<SpinnerOverlay
			v-show="spinner"
			class="spinner"
			cBackground="unset"
			cLeft="-5px"
			sWidth="30px"
			sHeight="30px"
		/>
		<CheckmarkIcon class="checkmark" :class="{ hide: !checkmark }" />
	</div>
</template>

<script>
import SpinnerOverlay from '@/components/SpinnerOverlay'
import { CheckmarkIcon } from '@/icons'

export default {
	props: ['spinner', 'noCheck'],
	components: { SpinnerOverlay, CheckmarkIcon },
	data() {
		return {
			checkmark: false,
		}
	},

	watch: {
		spinner: function (val, oldVal) {
			if (oldVal && !val && !this.noCheck) {
				this.showTimedCheckmark()
			}
		},
	},

	methods: {
		showTimedCheckmark() {
			this.checkmark = true
			setTimeout(() => {
				this.checkmark = false
			}, 2500)
		},
	},
}
</script>

<style scoped>
.spinner-checkmark-combo {
	position: relative;
	display: block;
	width: 30px;
}

.spinner,
.checkmark {
	position: absolute;
	height: 30px;
}

.checkmark {
	left: 5px;
	opacity: 1;
	background: transparent;
}

.hide {
	opacity: 0;
	transition: opacity 1s ease-out;
}
</style>
